/**
 * Shopify - Pestañas para descripción de producto
 * Este script convierte los elementos H5 en la descripción del producto en pestañas interactivas
 * Versión mejorada usando UL/LI para la navegación e incluye una pestaña de Descripción inicial
 */

(function() {
    // Ejecutar cuando el DOM está listo o cuando el contenido se haya cargado
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductTabs);
    } else {
      initProductTabs();
    }
  
    // También inicializar si hay cambios en el DOM (por si el contenido se carga dinámicamente)
    document.addEventListener('shopify:section:load', initProductTabs);
    
    /**
     * Inicializa las pestañas de producto
     */
    function initProductTabs() {
      // Seleccionar el contenedor de pestañas y la descripción del producto
      const tabsContainer = document.getElementById('product-tabs-container');
      const productDescription = tabsContainer ? tabsContainer.querySelector('.product-description') : null;
      
      if (!tabsContainer || !productDescription) return;
  
      // Limpiar contenido previo de pestañas (para prevenir duplicados en caso de reinicialización)
      const existingTabs = tabsContainer.querySelector('.product-tabs');
      if (existingTabs) {
        existingTabs.remove();
      }
  
      // Buscar todos los elementos H5 (títulos de pestañas)
      const h5Elements = productDescription.querySelectorAll('h5');
      if (h5Elements.length === 0) {
        // Si no hay elementos H5, mostrar la descripción normal
        productDescription.style.display = 'block';
        return;
      }
  
      // Generar un ID único para este conjunto de pestañas (basado en timestamp)
      const tabsUniqueId = 'product-tabs-' + Date.now();
  
      // Crear el contenedor de pestañas
      const tabsComponent = document.createElement('div');
      tabsComponent.className = 'product-tabs';
      tabsComponent.id = tabsUniqueId;
  
      // Crear la navegación de pestañas usando UL/LI
      const tabsNav = document.createElement('ul');
      tabsNav.className = 'tabs-navigation';
      tabsNav.setAttribute('role', 'tablist');
      
      // Crear el contenido de las pestañas
      const tabsContent = document.createElement('div');
      tabsContent.className = 'tab-content';
  
      // Crear una pestaña inicial de "Descripción"
      const descTabId = `${tabsUniqueId}-tab-description`;
      const descPanelId = `${tabsUniqueId}-panel-description`;
      
      // Crear elemento LI para la pestaña de Descripción
      const descLi = document.createElement('li');
      descLi.className = 'tab-item active'; // Activa por defecto
      descLi.setAttribute('role', 'presentation');
      
      // Crear el enlace para la pestaña de Descripción
      const descLink = document.createElement('a');
      descLink.className = 'tab-link active'; // Activa por defecto
      descLink.id = descTabId;
      descLink.setAttribute('role', 'tab');
      descLink.setAttribute('aria-selected', 'true');
      descLink.setAttribute('aria-controls', descPanelId);
      descLink.setAttribute('data-tab-index', 'description');
      descLink.setAttribute('href', '#' + descPanelId);
      descLink.textContent = 'Descripción'; // Texto de la pestaña de Descripción
      
      // Agregar evento de clic al enlace
      descLink.addEventListener('click', handleTabClick);
      
      // Agregar el enlace al LI y el LI a la navegación
      descLi.appendChild(descLink);
      tabsNav.appendChild(descLi);
      
      // Crear el panel para el contenido de la Descripción
      const descPanel = document.createElement('div');
      descPanel.className = 'tab-panel active'; // Activo por defecto
      descPanel.id = descPanelId;
      descPanel.setAttribute('role', 'tabpanel');
      descPanel.setAttribute('aria-labelledby', descTabId);
      
      // Agregar el contenido inicial (antes del primer H5) al panel de Descripción
      let descContent = document.createDocumentFragment();
      let currentElement = productDescription.firstElementChild;
      
      while (currentElement && currentElement.tagName !== 'H5') {
        // Clonar el elemento para no eliminarlo del DOM original
        const clone = currentElement.cloneNode(true);
        descContent.appendChild(clone);
        
        // Avanzar al siguiente elemento
        currentElement = currentElement.nextElementSibling;
      }
      
      // Si no hay contenido antes del primer H5, agregar un mensaje predeterminado
      if (!descContent.hasChildNodes()) {
        const defaultText = document.createElement('p');
        defaultText.textContent = 'Información del producto.';
        descContent.appendChild(defaultText);
      }
      
      // Agregar el contenido al panel de Descripción
      descPanel.appendChild(descContent);
      tabsContent.appendChild(descPanel);
  
      // Procesar cada pestaña adicional (basada en H5)
      h5Elements.forEach((h5, index) => {
        // Crear IDs únicos para cada pestaña
        const tabId = `${tabsUniqueId}-tab-${index}`;
        const panelId = `${tabsUniqueId}-panel-${index}`;
        
        // Crear el contenedor para esta pestaña
        const tabPanel = document.createElement('div');
        tabPanel.className = 'tab-panel'; // No activo por defecto (la pestaña de Descripción está activa)
        tabPanel.id = panelId;
        tabPanel.setAttribute('role', 'tabpanel');
        tabPanel.setAttribute('aria-labelledby', tabId);
        
        // Recopilar el contenido para esta pestaña
        let currentElement = h5.nextElementSibling;
        while (currentElement && currentElement.tagName !== 'H5') {
          const clone = currentElement.cloneNode(true);
          tabPanel.appendChild(clone);
          
          // Pasar al siguiente elemento
          currentElement = currentElement.nextElementSibling;
        }
        
        // Crear el elemento LI para la navegación
        const tabLi = document.createElement('li');
        tabLi.className = 'tab-item'; // No activo por defecto
        tabLi.setAttribute('role', 'presentation');
        
        // Crear el elemento A dentro del LI
        const tabLink = document.createElement('a');
        tabLink.className = 'tab-link'; // No activo por defecto
        tabLink.id = tabId;
        tabLink.setAttribute('role', 'tab');
        tabLink.setAttribute('aria-selected', 'false');
        tabLink.setAttribute('aria-controls', panelId);
        tabLink.setAttribute('data-tab-index', index);
        tabLink.setAttribute('href', '#' + panelId);
        tabLink.innerHTML = h5.innerHTML;
        
        // Agregar evento de clic al enlace
        tabLink.addEventListener('click', handleTabClick);
        
        // Agregar el enlace al LI y el LI a la navegación
        tabLi.appendChild(tabLink);
        tabsNav.appendChild(tabLi);
        
        // Agregar el panel al contenido
        tabsContent.appendChild(tabPanel);
      });
      
      // Agregar todo al DOM
      tabsComponent.appendChild(tabsNav);
      tabsComponent.appendChild(tabsContent);
      tabsContainer.prepend(tabsComponent);
  
      /**
       * Maneja el clic en una pestaña
       * @param {Event} event - El evento de clic
       */
      function handleTabClick(event) {
        event.preventDefault();
        
        // Asegurarse de que event.currentTarget existe
        if (!event.currentTarget) return;
        
        // Obtener el índice de la pestaña
        const tabIndex = event.currentTarget.getAttribute('data-tab-index');
        
        // Activar la pestaña correspondiente
        activateTab(tabIndex);
        
        // Desplazarse al contenido de la pestaña si está fuera de la vista
        const tabPanel = document.getElementById(event.currentTarget.getAttribute('aria-controls'));
        if (tabPanel) {
          const rect = tabPanel.getBoundingClientRect();
          if (rect.top < 0 || rect.top > window.innerHeight) {
            tabPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }
  
      /**
       * Activa una pestaña específica
       * @param {string|number} tabIndex - Índice o ID de la pestaña a activar
       */
      function activateTab(tabIndex) {
        // Desactivar todas las pestañas (tanto LI como A)
        const allItems = tabsNav.querySelectorAll('.tab-item');
        const allLinks = tabsNav.querySelectorAll('.tab-link');
        const allPanels = tabsContent.querySelectorAll('.tab-panel');
        
        // Desactivar elementos LI
        allItems.forEach(item => {
          item.classList.remove('active');
        });
        
        // Desactivar enlaces A
        allLinks.forEach(link => {
          link.classList.remove('active');
          link.setAttribute('aria-selected', 'false');
        });
        
        // Desactivar paneles
        allPanels.forEach(panel => {
          panel.classList.remove('active');
        });
        
        // Buscar la pestaña a activar (puede ser por índice numérico o "description")
        let tabToActivate;
        
        if (tabIndex === 'description') {
          // Activar la pestaña de descripción
          tabToActivate = tabsNav.querySelector(`[data-tab-index="description"]`);
          const descPanel = document.getElementById(descPanelId);
          if (descPanel) descPanel.classList.add('active');
        } else {
          // Activar pestaña por índice numérico
          tabToActivate = tabsNav.querySelector(`[data-tab-index="${tabIndex}"]`);
          const targetPanel = document.getElementById(`${tabsUniqueId}-panel-${tabIndex}`);
          if (targetPanel) targetPanel.classList.add('active');
        }
        
        // Activar el LI y el enlace de la pestaña seleccionada
        if (tabToActivate) {
          const parentLi = tabToActivate.closest('.tab-item');
          if (parentLi) parentLi.classList.add('active');
          tabToActivate.classList.add('active');
          tabToActivate.setAttribute('aria-selected', 'true');
        }
      }
    }
  })();